import { render, staticRenderFns } from "./SanityPageHeader.vue?vue&type=template&id=7d79b6a2&scoped=true"
import script from "./SanityPageHeader.vue?vue&type=script&lang=js"
export * from "./SanityPageHeader.vue?vue&type=script&lang=js"
import style0 from "./SanityPageHeader.vue?vue&type=style&index=0&id=7d79b6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79b6a2",
  null
  
)

export default component.exports